import { MessageCircle } from "lucide-react";
import { useState } from "react";

const WhatsAppChat = () => {
  const [isHovered, setIsHovered] = useState(false);

  // ✅ Updated WhatsApp Business number (South Africa)
  // Remove leading zero when adding country code (27)
  const phoneNumber = "27846688875";
  const message =
    "Hi! I'm interested in your coldroom and airconditioning services.";

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Chat on WhatsApp"
    >
      <div className="flex items-center gap-2 py-3 px-4">
        <MessageCircle className="w-6 h-6" />
        <span
          className={`overflow-hidden transition-all duration-300 whitespace-nowrap ${
            isHovered ? "max-w-[140px] opacity-100" : "max-w-0 opacity-0"
          }`}
        >
          Chat with us
        </span>
      </div>
    </a>
  );
};

export default WhatsAppChat;
